import styled from "styled-components";
import { motion } from "framer-motion";
import { v } from "../../styles/variables";

export const CardStyle = styled(motion.div)`
	width: 150px;
	min-height: 200px;
	border-radius: 5px 5px 15px 15px;
	display: flex;
	flex-direction: column;
	background: ${({ theme }) => theme.bg};
	position: relative;
	box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
	overflow: hidden;
	z-index: 10;

	&::after {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 50%;
		height: 100%;
		background: ${({ theme }) => theme.primary2};
		opacity: 0.15;
		z-index: -1;
	}

	> div {
		flex-basis: 100px;
	}

	.triangle-top {
		position: absolute;
		width: 100%;
		height: 5%;
		background: ${({ theme }) => theme.primary2};
		border-radius: 0 0 50% 50%;
		box-shadow: 0 2px 4px rgba(57, 63, 72, 0.3);
	}

	.progress {
		position: relative;

		.icon {
			position: absolute;
			width: auto;
			top: 60%;
			left: 50%;
			transform: translate(-50%, -50%) scale(2);

			&.js {
				color: #efd81d;
			}

			&.html {
				color: #dd4b25;
			}

			&.react {
				color: #7cd9f4;
			}

			&.css {
				color: #2060aa;
			}
		}

		.circular {
			position: absolute;
			top: 60%;
			left: 50%;
			transform: translate(-50%, -50%) rotate(90deg);
			width: 100px;
			height: 100px;

			circle {
				width: 100px;
				height: 100px;
				stroke-width: 6;
				stroke: #000;
				fill: none;
				stroke-dasharray: 253;
				stroke-dashoffset: 253;

				&:nth-child(1) {
					stroke-dashoffset: 0;
					stroke: ${({ theme }) => theme.primary2};
					opacity: 0.5;
				}
				&:nth-child(2) {
					stroke: ${({ theme }) => theme.primary};
				}
			}
		}
	}

	.skill-name {
		text-align: center;

		h4 {
			padding-top: ${v.smallDist};
		}

		p {
			font-weight: bold;
			padding-top: 0.5rem;
		}
	}
`;
